import { Card, CardContent, CardHeader } from '@shared/ui/card';
import { cn } from '@shared/lib/utils';
import { Info } from 'lucide-react';
import React from 'react';

interface SetupStepCardProps {
  progress: number; // Example: 42
  className?: string;
}

const SetupStepCard: React.FC<SetupStepCardProps> = ({ progress, className }) => {
  const isCompleted = progress >= 100;
  const getStatusLabel = () =>
    isCompleted ? 'Completed' : 'In Progress';

  return (
    <Card
      className={cn('w-full  border rounded-xl shadow-sm bg-white', className)}
    >
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between">
          <div className="flex gap-3">
            <div className="p-2  text-blue-600 ">
              <Info className="w-5 h-5" />
            </div>
            <div>
              <h3 className="text-base font-semibold text-foreground">
                Overall Setup Progress
              </h3>
              <p className="text-xs text-muted-foreground">
                Shows the average completion status for all your utilities.
              </p>
            </div>
          </div>
          <span
            className={cn(
              'text-xs font-medium px-2 py-0.5 rounded-md self-start',
              isCompleted ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
            )}
          >
            {getStatusLabel()}
          </span>
        </div>
      </CardHeader>
       

      <CardContent className="pt-0">
        <div className="flex items-center justify-between text-sm font-medium mb-1">
          <span>Progress</span>
          <span className="text-blue-600">{progress}%</span>
        </div>

        <div className="w-full h-2 rounded-full bg-blue-100 overflow-hidden">
          <div
            className="h-full bg-blue-500 transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className="text-xs text-muted-foreground mt-2">
          {isCompleted
            ? 'Great job! All utilities are configured.'
            : 'Almost there! Complete all utilities to finish setup.'}
        </p>
      </CardContent>
    </Card>
  );
};

export default SetupStepCard;
